import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTermsConditionsIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M15 2.87915V7.87915H20",
			stroke: "#000000",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4 10.8792V6.87915C4 4.67001 5.79086 2.87915 8 2.87915H15L20 7.87915V18.8792C20 21.0883 18.2091 22.8792 16 22.8792V22.8792",
			stroke: "#000000",
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.5 16.8792L8.4375 18.8792L7.5 17.8792",
			stroke: "#000000",
			strokeWidth: 1.125,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 9,
			cy: 17.8792,
			r: 5,
			stroke: "#000000",
			strokeWidth: 1.5
		})
	]
});
export default SvgTermsConditionsIcon;
